import {axios} from "@/utilites/api";
import Config from "@/common/config";

const apiCompanions = '/companions'

const getBank = (id) => {
  return axios.get(Config.apiURL + apiCompanions + '/api/v1/banks/' + id)
}

const getAllBanks = () => {
    return axios.get(Config.apiURL + apiCompanions + '/api/v1/banks')
}

const createdBank = (parameters) => {
    return axios.post(Config.apiURL + apiCompanions + '/api/v1/banks', parameters)
}

const updateBank = (parameters) => {
    return axios.put(Config.apiURL + apiCompanions + '/api/v1/banks', parameters)
}

const deletedBank = (parameters) => {
    return axios.delete(Config.apiURL + apiCompanions + '/api/v1/banks/' + parameters.id, parameters)
}

export default {
    getBank,
    getAllBanks,
    createdBank,
    updateBank,
    deletedBank
}
